import { createAsyncThunk } from "@reduxjs/toolkit";

const API_BASE = process.env.REACT_APP_API_BASE;

/**
 * fetch all Default entries
 */
export const fetchDefaultItems = createAsyncThunk(
  "default/fetchItems",
  async () => {
    const res = await fetch(`${API_BASE}/api/default`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "partner",
      },
    });
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);
